import axios, { Method } from 'axios'
import { getGatewayHttpUrl } from '../../../utils/deviceGateway'
import { getCachedAuthToken } from './getCachedAuthToken'
import { useLiveViewStateStore } from '../LiveViewStore'

export const createGenericRequest = (
    baseURL: string | null,
    method: Method,
    data: any,
    path: string,
    binary?: boolean
) => {
    const baseUrlCleaned = baseURL?.replace('https://', '').replace('http://', '')

    const storeDeviceName = useLiveViewStateStore.getState().deviceName || 'unknown name'

    return axios
        .request({
            method: 'POST',
            url: getGatewayHttpUrl('/proxy'),
            data: {
                ip: baseUrlCleaned,
                path,
                method,
                auth_token: localStorage.getItem('liveViewAccessToken') || '',
                data,
                device_name: storeDeviceName
            },
            responseType: binary ? 'arraybuffer' : 'json',
            headers: {
                'Content-Type': 'application/json',
                Accept: '*/*',
                Authorization: getCachedAuthToken()
            }
        })
        .catch((error: unknown) => {
            // A 502/503/504 or a network error (no response) from the gateway means the device is
            // temporarily unreachable — an expected operational condition, not a bug. The gateway
            // raises 504 itself on device timeout, so this is not worth reporting: log at info level
            // (which Sentry's console integration does not capture) and surface a message in the UI.
            const status = axios.isAxiosError(error) ? error.response?.status : undefined
            const isDeviceUnreachable =
                (status !== undefined && [502, 503, 504].includes(status)) ||
                (axios.isAxiosError(error) && !error.response)
            if (isDeviceUnreachable) {
                console.info('Live view device request failed (device unreachable):', error)
                useLiveViewStateStore
                    .getState()
                    .setErrorMessage('Device is temporarily unreachable — please try again in a moment.')
            } else {
                console.error('Live view device request failed:', error)
            }
            // Re-throw so awaiting callers keep their existing success/failure handling.
            throw error
        })
}
